import React, { Component } from 'react';
import MatchHydrate from './../match-hydrate.js';
import AccountSettingsEmail from './account-settings-email.js';
import AccountSettingsMobile from './account-settings-mobile.js';

class AccountSettings extends Component {
	componentWillMount() {
		//menuesRootview.openMySettings();

	}

	componentWillUnmount() {
		//menuesRootview.closeMySettings();

	}

	render() {
		return (
			<div id="account-settings">
				<MatchHydrate authenticate path="/account/mysettings/verify-email" component={AccountSettingsEmail} />
				<MatchHydrate authenticate path="/account/mysettings/verify-mobile" component={AccountSettingsMobile} />
			</div>
		);
	}
}

export default AccountSettings;




// WEBPACK FOOTER //
// ./mobile-core/src/components/account/account-settings.js